import { css } from 'linaria';
import { strictBreakpoints } from '../../../media';

export const otherServicesStyles = css`
	margin-top: 80px;
	background: var(--background-secondary);
	${strictBreakpoints.onlyTablet} {
		margin-top: 64px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-top: 40px;
	}
`;
export const otherServicesContainerStyles = css`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 24px;
	margin-top: 24px;
	${strictBreakpoints.onlyTablet} {
		gap: 16px;
	}
	${strictBreakpoints.onlyMobile} {
		display: none;
	}
`;
export const otherServicesWrapperStyles = css`
	padding: 80px 93px;
	${strictBreakpoints.onlyDesktop} {
		padding: 80px 42px;
	}
	${strictBreakpoints.onlyTablet} {
		padding: 64px 54px;
	}
	${strictBreakpoints.onlyMobile} {
		padding: 40px 16px 0px 16px;
	}
`;
